module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-dropdown', {
    attrs: {
      "size": "sm",
      "variant": _vm.currentStatus.color,
      "disabled": _vm.saving
    }
  }, [_c('template', {
    slot: "button-content"
  }, [(_vm.saving) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin mr-1"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.currentStatus.label) + "\n    ")]), _vm._v(" "), _vm._l((_vm.selectableStatuses), function(status) {
    return _c('b-dropdown-item', {
      key: status.id,
      class: ("bg-" + (status.color)),
      staticStyle: {
        "color": "#fff !important"
      },
      on: {
        "click": function($event) {
          _vm.updateStatus(status.id)
        }
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('text-alert', {
    staticClass: "ml-1",
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d89a908","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/order-lists/OrderListStatusBadge.vue
// module id = 714
// module chunks = 1